import { useSetRecoilState } from 'recoil';

import { OrganizationsService } from 'shared/services/organizations/organizationsService';

import { IOrganization } from 'shared/types';

import { selectedOrganization, organizationList } from './atoms';

export const useOrganizationActions = () => {
  //const organizationService = useOrganizationService();
  const setSelectedOrganization = useSetRecoilState(selectedOrganization);
  const setOrganizations = useSetRecoilState(organizationList);

  const getOrganizations = async () => {
    return OrganizationsService
      .getOrganizations()
      .then((result) => {
        if(result instanceof Error){
          setOrganizations([]);
          return;
        }
        setOrganizations(result);
        return result;
      })
      .catch((e) => {
        setOrganizations([]);
        throw e;
      });
  };

  const setSelOrganization = (organization: IOrganization | null) => {
    setSelectedOrganization(organization);
  };

  return {
    getOrganizations,
    setSelectedOrganization: setSelOrganization,
  };
};
